<template>
    <div class="shop-list-card-wrapper">
        <div class="shop-list-card-inner">
            <div class="shop-list-card-picture">
                <!-- <img class="shop-list-card-img" src="https://eshop-cdn.vermont.eu/library/2022/05/6dRBLKsb5iH9UJZbIsmyl0VEzdHcpmm1Fxn29eJM.jpg" alt="" width="390" height="309" /> -->
                <img
                    class="shop-list-card-img"
                    :src="$storageUrl + store.image"
                    :alt="__('frontend_js.images_alt.store') + ' - ' + store.title" width="390" height="309"
                />
            </div>
            <div class="shop-list-card-info">
                <div class="shop-list-card-title">
                    {{ store.title }}
                </div>
                <div class="shop-list-card-column-wrapper">
                    <div class="shop-list-card-column">
                        <div class="shop-list-card-row">
                            <div class="shop-list-card-column-header">
                                {{ __('frontend_js.stores.vermont_store_card.address') }}
                            </div>
                            <div class="shop-list-card-column-text">
                                {{ store.address.street }},
                                {{ store.cities[0].title }}
                            </div>
                        </div>

                        <div class="shop-list-card-row">
                            <div class="shop-list-card-column-header">
                                {{ __('frontend_js.stores.vermont_store_card.phone') }}
                            </div>
                            <div class="shop-list-card-column-text">
                                {{ phone_number }}
                            </div>
                        </div>
                    </div>
                    <div class="shop-list-card-column">
                        <div class="shop-list-card-row">
                            <div class="shop-list-card-column-header">
                                {{ __('frontend_js.stores.vermont_store_card.open_hours') }}
                            </div>
                            <div class="shop-list-card-column-text">
                                <div v-if="store.currentOpenHour.is_open">
                                    {{ __('frontend_js.stores.vermont_store_card.today_open') }}
                                    {{ store.currentOpenHour.start_time }}
                                    —
                                    {{ store.currentOpenHour.end_time }}
                                </div>
                                <div v-else>
                                    {{ __('frontend_js.stores.vermont_store_card.today_closed') }}
                                </div>
                            </div>
                        </div>
                        <div class="shop-list-card-row">
                            <div class="shop-list-card-column-header">
                                {{ __('frontend_js.stores.vermont_store_card.brands_selling') }}
                            </div>
                            <div class="shop-list-card-column-text">
                                {{ trademarks }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="shop-list-card-buttons">
                <div class="shop-list-button">
                    <a :href="'/' + store.slug" class="text-uppercase shop-button anchor-button no-underline">
                        {{ __('frontend_js.stores.vermont_store_card.store_details') }}
                    </a>
                </div>

                <div class="shop-list-button" v-show="store.onlineShoppingButton.url !== null">
                    <a
                        class="text-uppercase shop-button anchor-button no-underline"
                        :href="store.onlineShoppingButton.url"
                        :target="store.onlineShoppingButton.new_tab ? '_blank' : '_self'"
                    >
                        {{ __('frontend_js.stores.vermont_store_card.shop_online') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        store: { required: true },
    },
    data() {
        return {
            trademarks: '',
            phone_number: '',
        };
    },
    methods: {
        // method setupTrademarks:
        // just for styling purposes, if there is only one trademark, then no comma,
        // otherwise comma, except last element
        setupTrademarks() {
			this.trademarks = this.store.trademarks.map(trademark => trademark.title).join(', ');
            // const trademarksArr = [];

            // Object.entries(this.store.trademarks).forEach(item => {
            //     // Vermont trademark hidden, business requirements as this trademark have only giftbox, etc.
            //     if (item[1].title !== 'Vermont') {
            //         trademarksArr.push(item[1].title);
            //     }
            // });
            // this.trademarks = trademarksArr.join(', ');
        },
        // method just to format phone number adding spaces every 3rd char
        setupNumber() {
            let spacedNumber;
            spacedNumber = Array.from(this.store.phone_number.substring(1))
                .reverse()
                .join('')
                .match(/.{1,3}/g)
                .join(' ');
            spacedNumber = Array.from(spacedNumber.trim()).reverse().join('');

            this.phone_number = '+' + spacedNumber;
        },
    },
    created() {
        this.setupTrademarks();
        this.setupNumber();
    },
};
</script>
